import { Container } from './Container';
import { HeaderRoot } from './Header';
import { HeaderContent } from './Content';
import { HeaderLogo } from './Logo';
import { HeaderCloseButton } from './CloseButton';
import { HeaderTitles } from './Titles';

export default {
  Container,
  HeaderRoot,
  HeaderContent,
  HeaderLogo,
  HeaderCloseButton,
  HeaderTitles,
};
